export default __webpack_public_path__ + "static/media/logo.11a82427.svg";